<template>
  <v-footer class="text-left d-flex flex-column ga-2 py-4" color="purple-darken-4">
    <div class="d-flex ga-3">
        <v-btn
          v-for="social in socialMedia"
          :key="social.icon"
          :icon="social.icon"
          :href="social.link"
          density="comfortable"
          variant="text"
        ></v-btn>
    </div>

    <v-container fluid :class="containerClasses">
     <v-row class="d-flex justify-space-around">
       <v-divider color="red" opacity=".7" thickness="3" gradient vertical></v-divider>
      <v-col>
        <div :class="titleClasses">Majed Photograph</div>
        <v-divider class="my-2 w-50" thickness="2" gradient ></v-divider>

        <div :class="bodyTextClasses" class="ma-2">
          Professionelle Fotografie-Dienstleistungen für unvergessliche Momente und beeindruckende visuelle Geschichten.
        </div>
      </v-col>
       <v-divider color="red" opacity=".7" thickness="3" gradient vertical></v-divider>
      <v-col>
        <div :class="titleClasses" class="mb-2">Übersicht</div>
        <v-divider class="my-2 w-50" thickness="2" gradient ></v-divider>

        <div :class="bodyTextClasses" class="ma-2 cursor-pointer hover-text" @click="scrollToSection('HOME')">Startseite</div>
        <div clickable :class="bodyTextClasses" class="ma-2 cursor-pointer hover-text" @click="scrollToSection('ABOUT_ME')">Über mich</div>
        <div :class="bodyTextClasses" class="ma-2 cursor-pointer hover-text" @click="scrollToSection('PROJECTS')">Projekte</div>
        <div :class="bodyTextClasses" class="ma-2 cursor-pointer hover-text" @click="scrollToSection('SERVICES')">Leistungen</div>
        <div :class="bodyTextClasses" class="ma-2 cursor-pointer hover-text" @click="scrollToSection('TESTIMONIALS')">Kundenstimmen</div>
        <div :class="bodyTextClasses" class="ma-2 cursor-pointer hover-text" @click="scrollToSection('AQ')">Q&A</div>
        <div :class="bodyTextClasses" class="ma-2 cursor-pointer hover-text" @click="scrollToSection('CONTACT')">Kontakt</div>  
      </v-col>
      <!-- <v-divider color="red" opacity=".7" thickness="3" gradient vertical></v-divider>
      <v-col>
        <div :class="titleClasses">Rechtsdokumente</div>
        <v-divider class="my-2 w-50" thickness="2" gradient ></v-divider>

        <div :class="bodyTextClasses" class="ma-2">Datenschutz</div>
        <div :class="bodyTextClasses" class="ma-2">Impressum</div>
        <div :class="bodyTextClasses" class="ma-2">AGB</div>
      </v-col> -->
      <v-divider color="red" opacity=".7" thickness="3" gradient vertical></v-divider>

      <v-col>
        <v-list-item class="px-0">
          <template v-slot:prepend>
            <v-avatar 
              :image="require('../assets/majed.png')" 
              size="80"
              class="border-sm bg-purple-darken-4 elevation-5"
            ></v-avatar>
          </template>
          
          <v-list-item-title :class="titleClasses">
            Majed Muhanaia
          </v-list-item-title>
          
          <v-list-item-subtitle :class="subtitleClasses">
            Gründer
          </v-list-item-subtitle>
        </v-list-item>
        <v-divider class="my-2 w-25" thickness="2" width="50" gradient></v-divider>
        <div :class="subtitleClasses" class="font-weight-regular opacity-60">
          <v-icon class="mr-1" color="primary">mdi-format-quote-open</v-icon>
          Mit Leidenschaft für außergewöhnliche Bilder. Ich halte deine wertvollsten Momente fest - von Porträts über Hochzeiten bis zur Unternehmensfotografie. Jedes Bild erzählt eine Geschichte.
          <v-icon class="ml-auto" color="primary">mdi-format-quote-close</v-icon> - Majed Muhanaia
        </div>

        <!-- Unter dem Zitat, über den Social-Media-Buttons -->
        <div class="mt-4">
          <!-- Vertrauenspunkte in einer Zeile -->
          <div class="d-flex flex-wrap justify-center ga-2 mb-3">
            <v-chip size="small" color="success" variant="outlined" prepend-icon="mdi-account-group">
              100+ Kunden
            </v-chip>
            <!-- <v-chip size="small" color="warning" variant="outlined" prepend-icon="mdi-trophy">
              Preisgekrönt 2023
            </v-chip> -->
            <v-chip size="small" color="blue-lighten-1" variant="outlined" prepend-icon="mdi-shield-check">
              100% Garantie
            </v-chip>
          </div>

          <!-- CTA Button groß -->
          <v-btn 
            color="red-darken-3" 
            variant="flat" 
            block 
            class="mb-3"
            size="large"
            @click="scrollToSection('CONTACT')"
          >
            <v-icon class="mr-2">mdi-calendar-clock</v-icon>
            Termin: 030-1234567
          </v-btn>
        </div>
      </v-col>

     </v-row>
    </v-container>

    <v-divider class="my-2 w-100" thickness="2" ></v-divider>

    <v-divider></v-divider>

    <div class="text-caption font-weight-regular opacity-60">
     © {{ new Date().getFullYear() }} - <strong>Majed Photography.</strong> Alle Rechte vorbehalten.
      <a href="/agb" class="text-white opacity-75">AGB</a> | 
      <a href="/impressum" class="text-white opacity-75">Impressum</a> | 
      <a href="/datenschutz" class="text-white opacity-75">Datenschutz</a>
    </div>
  </v-footer>
</template>

<script setup>
</script>

<script lang="ts">
import { defineComponent } from 'vue';
import { useResponsive } from '@/composables/useResponsive';
import { scrollService } from '@/services/scrollService';

export default defineComponent({
  name: 'FooterComponent',
  
  setup(){
    const currentYear = new Date().getFullYear();
    const socialMedia = [
      { icon: 'mdi-facebook', link: 'https://facebook.com' },
      { icon: 'mdi-instagram', link: 'https://www.instagram.com/majed_muhanaia/' },
      { icon: 'mdi-linkedin', link: 'https://linkedin.com' },
    ]


    const responsive = useResponsive();
    const founderImage = '../assets/majed.png';



    const scrollToSection = (sectionId: string) => {
      scrollService.scrollToSection(sectionId);
    };

    return {
      currentYear,
      socialMedia,
      ...responsive,
      founderImage,

      scrollToSection
    };
  }
});
</script>